import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { useApi } from 'utils/api';
import { ProgressiveResponse } from 'features/types';
import { ServiceLine } from 'components/question_types/selector/BankSelectorV1/BankSelectorV1';
import { Store } from 'types/store';

export const useGetNotSureServiceLine = (isDisabled = false): ProgressiveResponse<ServiceLine[]> => {
  const api = useApi();
  const serviceLinesEndpoint = '/api/service_lines?name=not_sure';
  const user = useSelector((store: Store) => store.global_reducer.current_user);

  const { data, isLoading, isSuccess, status } = useQuery({
    queryKey: ['serviceLinesData', user.attributes.patient?.id, isDisabled],
    queryFn: () => api.get<ServiceLine[]>(serviceLinesEndpoint),
    enabled: !!api && !isDisabled,
    meta: {
      errorMessage: 'Error when call API /api/service_lines?name=not_sure',
      tags: ['useGetNotSureServiceLine', 'error', 'serviceLines'],
      apiName: serviceLinesEndpoint,
      userId: user.attributes.patient?.id
    }
  });

  return useMemo(() => ({ isLoading, isSuccess, data: data?.data || [], status }), [data, isLoading]);
};
